import { render } from "./homeArticles.vue?vue&type=template&id=07b4f39b&scoped=true&lang=html"
import script from "./homeArticles.vue?vue&type=script&lang=js"
export * from "./homeArticles.vue?vue&type=script&lang=js"

import "./homeArticles.vue?vue&type=style&index=0&id=07b4f39b&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b4f39b"]])

export default __exports__